import { ServiceMeterTypeEnum } from "@monorepo/types";

export const isCounterWarning = (data?: any, parameters?: any) => {
  const counters: Array<{ from: number; to: number }> = [];
  parameters.forEach((x: any, index) => {
    if (
      x.group_label &&
      x.meter_type === ServiceMeterTypeEnum.FROM &&
      parameters[index + 1]?.group_label === x.group_label &&
      parameters[index + 1]?.meter_type === ServiceMeterTypeEnum.TO
    ) {
      counters.push({
        from: Number(data[x.parameter_name]),
        to: Number(data[parameters[index + 1]?.parameter_name]),
      });
    }
  });
  let warning = false;
  counters.forEach((x) => {
    if (x.to - x.from > 1000) {
      warning = true;
    }
  });
  return warning;
};
